module.exports = __webpack_public_path__ + "static/img/Ellipse 1 (Stroke).f0204b6b.png";